/**
 * Central export for veehive images (moved from images.veehive.ai to local assets).
 * Icons in icons/, others in assets root.
 */

// Icons (src/assets/icons/)
import appliedIcon from "./icons/applied-icon.png";
import shortlistedIcon from "./icons/shortlisted-icon.png";
import screeningIcon from "./icons/screening-icon.png";
import interviewIcon from "./icons/interview-icon.png";
import offeredIcon from "./icons/offered-icon.png";
import onholdIcon from "./icons/onhold-icon.png";
import hiredIconStar from "./icons/hired-icon-star.png";
import editIcon from "./icons/edit-icon.png";
import jobIcon from "./icons/job-icon.png";
import gradIcon from "./icons/grad-icon.png";
import eyeIcon from "./icons/eye-icon.png";
import pdfIcon from "./icons/PDF.png";
import emiratiProfileIcon from "./icons/emiratiProfileIcon.png";
import jobsPostedIcon from "./icons/jobsPostedIcon.png";
import applicationsIcon from "./icons/applicationsIcon.png";
import placementsIcon from "./icons/placementsIcon.png";
import jobViewsIcon from "./icons/jobViewsIcon.png";

// Others (src/assets/)
import tick03 from "./tick-03.png";
import lock1 from "./Lock+1.png";
import otpemail from "./otpemail.png";
import companyLogoUpdate from "./CompanyLogoUpdate.png";
import tech from "./tech.png";
import engg from "./engg.png";
import biz from "./biz.png";
import hr from "./hr.png";
import finance from "./finance.png";
import marketing from "./marketing.png";
import design from "./design.png";
import sales from "./sales.png";
import imgQrCodeBlack from "./img-qr-code-black.png.png";
import appstore from "./appstore.png";
import playstore from "./playstore.png";
import ftMockupsNew from "./iphone16ProMockup.png";
import btnArrow from "./btnArrow.png";
import appShowcase from "./appShowcase.png";
import appShowCaseMobile from "./appShowCaseMobile.png";
import effortless from "./effortless.png";
import craftStory from "./craftStory.png";
import setSights from "./setSights.png";
import forEmployers from "./forEmployers.png";
import tascBlueLogo from "./tasc-blue-logo.png";
import newImgHero from "./newImgHero.png";
import connectWith from "./connectWith.png";
import hireTalents from "./hireTalents.png";
import jobHub from "./jobHub.png";
import freeAccessImgNew from "./freeAccessImgNew.png";
import dashboardSnippetNew from "./dashboardSnippetNew.png";
import dashboardSnippetMobile from "./dashboardSnippetMobile.png";
import jobseekers from "./jobseekers.png";
import macbookProMockup from "./Macbook+Pro+Mockup+Light+1.png";
import cancel02 from "./cancel-02.png";
import menuNew from "./menuNew.png";
import closeMenu from "./closeMenu.png";
import user from "./user.png";
import briefcase from "./briefcase.png";
import logoEditPen from "./LogoEditPen.png";
import tascBrandLogo from "./forsatak-logo.svg";
import ftNewb2 from "./ft_newb2.png";
import ftBrandLaptop from "./ft_brand_laptop.png";
import ftBrandNewphone from "./ft_brand_newphone.png";
import ftBrandAppstore from "./ft_brand_appstore.png";
import ftBrandPlay from "./ft_brand_play.png";
import macbookProLight from "./macbookProLight.png";

export const icons = {
  applied: appliedIcon,
  shortlisted: shortlistedIcon,
  screening: screeningIcon,
  interview: interviewIcon,
  offered: offeredIcon,
  onhold: onholdIcon,
  hiredStar: hiredIconStar,
  edit: editIcon,
  job: jobIcon,
  grad: gradIcon,
  eye: eyeIcon,
  pdf: pdfIcon,
  emiratiProfile: emiratiProfileIcon,
  jobsPosted: jobsPostedIcon,
  applications: applicationsIcon,
  placements: placementsIcon,
  jobViews: jobViewsIcon,
};

export const images = {
  tick03,
  lock1,
  otpemail,
  companyLogoUpdate,
  tech,
  engg,
  biz,
  hr,
  finance,
  marketing,
  design,
  sales,
  imgQrCodeBlack,
  appstore,
  playstore,
  ftMockupsNew,
  btnArrow,
  appShowcase,
  appShowCaseMobile,
  effortless,
  craftStory,
  setSights,
  forEmployers,
  tascBlueLogo,
  newImgHero,
  connectWith,
  hireTalents,
  jobHub,
  freeAccessImgNew,
  dashboardSnippetNew,
  dashboardSnippetMobile,
  jobseekers,
  macbookProMockup,
  cancel02,
  menuNew,
  closeMenu,
  user,
  briefcase,
  logoEditPen,
  tascBrandLogo,
  ftNewb2,
  ftBrandLaptop,
  ftBrandNewphone,
  ftBrandAppstore,
  ftBrandPlay,
  macbookProLight,
};
